import { createSlice } from '@reduxjs/toolkit';

import { getAllState, getAllDistrict } from '../api/region';

export const regionSlice = createSlice({
  name: 'region',
  initialState: {
    loading: false,
    districtLoading: false,
    error: {},
    districts: {},
    states: {},
  },
  reducers: {},
  extraReducers: {
    // state

    [getAllState.pending]: (state) => {
      state.loading = true;
    },
    [getAllState.fulfilled]: (state, action) => {
      state.loading = false;
      state.states = action.payload;
    },
    [getAllState.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // district
    [getAllDistrict.pending]: (state) => {
      state.districtLoading = true;
    },
    [getAllDistrict.fulfilled]: (state, action) => {
      state.districtLoading = false;
      state.districts = action.payload;
    },
    [getAllDistrict.rejected]: (state, action) => {
      state.districtLoading = false;
      state.error = action.error;
    },
  },
});

export default regionSlice.reducer;
